export default "__VITE_ASSET__DTovAA4d__"